/* DROP theme: homepage (hero, brand index, lookbook) */
(() => {
  const DROP = window.DROP; const { $, $$ } = DROP;

  const hero = () => {
    const h = $('#hero'); if (!h || h._init) return; h._init = 1;
    (DROP.introDone || Promise.resolve()).then(() => setTimeout(() => { h.classList.add('in'); $$('.hero__title .split-line', h).forEach(s => s.classList.add('in')); }, 80));
  };

  /* brand index: the brand in the middle of the screen lights up as you scroll */
  const bindex = sec => {
    if (sec._init) return; sec._init = 1;
    const bl = $('.blist', sec), pv = $('.bindex__pv', sec), pvImg = $('img', pv), pvT = $('.bpv-t', pv);
    let lock = false, ticking = false;
    const setActive = li => {
      if (!li || li.classList.contains('is-active')) return;
      $$('li.is-active', bl).forEach(x => x.classList.remove('is-active')); li.classList.add('is-active');
      const a = $('a', li); pv.href = a.href; pvT.textContent = [a.dataset.name, a.dataset.count].filter(Boolean).join(' · ');
      if (a.dataset.img && pvImg.getAttribute('src') !== a.dataset.img) { pvImg.style.opacity = 0; pvImg.onload = () => (pvImg.style.opacity = 1); pvImg.src = a.dataset.img; }
    };
    const byScroll = () => {
      ticking = false; if (lock) return;
      const r0 = bl.getBoundingClientRect(); if (r0.bottom < -200 || r0.top > innerHeight + 200) return;
      const mid = innerHeight * 0.5; let best = null, bd = Infinity;
      $$('li:not([hidden])', bl).forEach(li => { const r = li.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - mid); if (d < bd) { bd = d; best = li; } });
      setActive(best);
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(byScroll); } }, { passive: true });
    setActive($('li', bl)); setTimeout(byScroll, 0);
    if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
      $$('li', bl).forEach(li => li.addEventListener('pointerenter', e => { if (e.pointerType !== 'mouse') return; lock = true; setActive(li); }));
      bl.addEventListener('mouseleave', () => { lock = false; byScroll(); });
      const warm = () => $$('a', bl).forEach(a => { if (a.dataset.img) { const i = new Image(); i.src = a.dataset.img; } });
      'requestIdleCallback' in window ? requestIdleCallback(warm) : setTimeout(warm, 2000);
    }
    $$('.seg button', sec).forEach(b => (b.onclick = () => {
      $$('.seg button', sec).forEach(x => x.setAttribute('aria-pressed', x === b)); const f = b.dataset.f;
      $$('li', bl).forEach(li => (li.hidden = f === 'hg' ? li.dataset.hg !== '1' : f === 'global' ? li.dataset.hg === '1' : false));
      $('li.is-active', bl)?.classList.remove('is-active'); lock = false; byScroll();
      if (!$('li.is-active', bl)) setActive($('li:not([hidden])', bl));
    }));
  };

  /* lookbook: points highlight their piece, the button adds the whole look */
  const look = sec => {
    if (sec._init) return; sec._init = 1;
    const list = $('.look__list', sec);
    $$('.spot', sec).forEach(s => {
      const on = v => { list.classList.toggle('focus', v); $$('.look__item', list).forEach(x => x.classList.toggle('on', v && x.dataset.i === s.dataset.i)); s.setAttribute('aria-pressed', v); };
      s.onmouseenter = () => on(true); s.onmouseleave = () => on(false); s.onfocus = () => on(true); s.onblur = () => on(false);
      s.onclick = () => (location.href = s.dataset.url);
    });
    const btn = $('[data-look-add]', sec);
    if (btn) btn.onclick = async () => {
      const ids = btn.dataset.lookAdd.split(',').filter(Boolean).map(id => ({ id: +id, quantity: 1 }));
      if (!ids.length || btn.dataset.busy) return; btn.dataset.busy = 1;
      const first = $('.look__item', list), img = first && $('img', first);
      try { await DROP.cart.add(ids, 1, { title: btn.dataset.added || btn.textContent.trim(), img: img?.currentSrc || img?.src }); } finally { delete btn.dataset.busy; }
    };
  };

  const init = (root = document) => { hero(); $$('[data-bindex]', root).forEach(bindex); $$('[data-look]', root).forEach(look); };
  init();
  document.addEventListener('drop:section', e => init(e.detail));
})();
